import React from 'react';

interface State {
  hasError: boolean;
  error: Error | null;
}

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * ErrorBoundary — cattura eccezioni nel rendering React.
 * Su Capacitor WebView evita la schermata bianca (non c'è barra indirizzi per ricaricare).
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('[ErrorBoundary] React render error:', error, info.componentStack);
  }

  handleReload = (): void => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: 40,
            textAlign: 'center',
            color: '#fff',
            background: '#1a1a2e',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>
            Qualcosa è andato storto
          </h2>
          <p style={{ marginTop: 8, color: '#94a3b8', fontSize: 14, maxWidth: 300 }}>
            Si è verificato un errore imprevisto. Riprova a ricaricare l'app.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: 24,
              padding: '12px 32px',
              background: '#FF5A1F',
              border: 'none',
              borderRadius: 8,
              color: '#fff',
              fontSize: 16,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            🔄 Ricarica App
          </button>
          {this.state.error && (
            <details style={{ marginTop: 16, color: '#64748b', fontSize: 12, maxWidth: '90%' }}>
              <summary>Dettagli tecnici</summary>
              <pre style={{ textAlign: 'left', overflow: 'auto' }}>
                {this.state.error.message}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
